<template>
  <span :class="$attrs.class" :style="rootStyle">
    <template v-for="(ch, index) in chars" :key="index">
      <!-- 数字字符 → 纵向 0-9 数字条 -->
      <span v-if="/\d/.test(ch)" :style="digitWrapStyle" aria-hidden="true">
        <span :style="getDigitTrackStyle(Number(ch))">
          <span v-for="d in DIGITS" :key="d" :style="digitItemStyle">{{ d }}</span>
        </span>
      </span>
      <!-- 非数字字符 → 静态渲染 -->
      <span v-else :style="charStyle">{{ ch }}</span>
    </template>
    <!-- 无障碍：真实文本让屏幕阅读器直接读出 -->
    <span :style="srOnlyStyle">{{ text }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent, computed, type CSSProperties, type PropType } from 'vue'

const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

export default defineComponent({
  name: 'ScrollingNumber',
  inheritAttrs: false,
  props: {
    text: { type: String, required: true },
    style: { type: Object as PropType<CSSProperties>, default: () => ({}) },
    duration: { type: Number, default: 700 },
  },
  setup(props) {
    const easing = 'cubic-bezier(0.25, 0.8, 0.25, 1)'

    const chars = computed(() => Array.from(String(props.text)))

    const rootStyle = computed<CSSProperties>(() => ({
      display: 'inline-flex',
      alignItems: 'baseline',
      whiteSpace: 'nowrap',
      ...props.style,
    }))

    const digitWrapStyle: CSSProperties = {
      display: 'inline-block',
      height: '1em',
      lineHeight: '1em',
      overflow: 'hidden',
      verticalAlign: 'baseline',
    }

    const digitItemStyle: CSSProperties = { height: '1em', lineHeight: '1em' }

    const charStyle: CSSProperties = { display: 'inline-block', lineHeight: '1em' }

    const srOnlyStyle: CSSProperties = {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
      whiteSpace: 'nowrap',
      border: '0',
    }

    const getDigitTrackStyle = (digit: number): CSSProperties => ({
      display: 'inline-flex',
      flexDirection: 'column',
      transform: `translateY(-${digit}em)`,
      transition: `transform ${props.duration}ms ${easing}`,
 willChange: 'transform',
    })

    return { chars, rootStyle, digitWrapStyle, digitItemStyle, charStyle, srOnlyStyle, getDigitTrackStyle, DIGITS }
  },
})
</script>